import Img from '../assets/imgs/user.jpg'


export const googleData = [
  {
    id: 1,
    title: 'Online meeting',
    position: { lat: 41.2965, lng: 69.2501 },
    icon: {
      url: Img
    }, status: 'offline',
    name: "Kitob Dokoni",
    content: {
      time: '11:00 ~ 12:00',
      people: "Ali"
    },
  },
  {
    id: 2,
    title: 'Dinner with Sardor',
    position: { lat: 41.2935, lng: 69.2401 },
    icon: {
      url: Img
    }, status: 'offline',
    name: "Al-Noor Caffee",
    content: {
      time: '11:00 ~ 12:00',
      people: "Ali"
    },
  },
  {
    id: 3,
    title: 'Coffee time',
    position: { lat: 41.2915, lng: 69.2801 },
    icon: {
      url: Img
    }, status: 'offline',
    name: "Al-Noor Caffe",
    content: {
      time: '11:00 ~ 12:00',
      people: "Ali"
    },
  }
]